import React from 'react'
import filesize from 'filesize'
import { post } from '~/utils/api'
import { notify } from '~/utils/notify'
import { AttachmentsType } from '../../Show'

type Props = {
  attachments: AttachmentsType[]
}

const download = async (e: React.MouseEvent<HTMLAnchorElement>, id: number) => {
  e.preventDefault()

  const res: { url?: string; error?: string } = await post(
    `tickets/attachment/${id}/download`
  )
  res.error && notify(res.error, 'error')
  res.url && window.open(res.url, '_blank')
}

const Attachments: React.FC<Props> = ({ attachments }) => (
  <>
    <div className="attachments ticket-show-answers__attachments">
      <ul>
        {attachments.map(item => (
          <li key={item.id}>
            <span className="fas fa-file-download ticket-show-answers__icon"></span>
            <a
              onClick={e => download(e, item.id)}
              className="ticket-show-answers__link"
            >
              {item.name}
            </a>
            <span>({filesize(item.size)})</span>
          </li>
        ))}
      </ul>
    </div>
  </>
)

export default Attachments
